export function getDistanceBetweenPoints(
  point1: [number, number],
  point2: [number, number]
): number {
  const R = 6371;
  const dLon = ((point2[0] - point1[0]) * Math.PI) / 180;
  const dLat = ((point2[1] - point1[1]) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((point1[1] * Math.PI) / 180) *
      Math.cos((point2[1] * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
